export default "__VITE_ASSET__52f3e589__"